import React from "react";
import { useAuth } from "../../src/Context/AuthContext";


const AgentWelcomeSection = ({ portalSettings }) => {
    const { isAuthenticated, user, logout, loading } = useAuth();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;

    //Load PSM
    if (loading || !portalSettings) return null;
    const psm = portalSettings || {};

    return (
        <div className="agent-welcome-section">
            <div className="agent-welcome-card">
                {psm.companyLogo && (
                    <div className="agent-welcome-logo-container">
                        <div className="agent-welcome-logo-box">
                            <img
                                src={`https://insuranceservices.actmanre.com/AMRImages/${psm.groupCode}/${psm.companyLogo}`}
                                alt="Agent Welcome Logo"
                                className="agent-welcome-logo"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/home")}
                            />
                        </div>
                    </div>
                )}

                <div className="agent-welcome-content">
                    <h1>
                        Welcome to {companyName}
                    </h1>

                    <p>
                        Access your account information, documents, commissions,
                        statements, and other available resources.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AgentWelcomeSection;